import { createAction } from "redux-act";
import { ENTITY } from "./propertyAmenity.constants";
var getPrefix = function (action) { return "".concat(ENTITY, "/").concat(action); };
// Get by property ID actions
export var getByPropertyIdStart = createAction(getPrefix("GET_BY_PROPERTY_ID_START"));
export var getByPropertyIdSucceeded = createAction(getPrefix("GET_BY_PROPERTY_ID_SUCCEEDED"));
export var getByPropertyIdFailed = createAction(getPrefix("GET_BY_PROPERTY_ID_FAILED"));
